<template>
  <div>
    <!-- Hero Section -->
    <div class="tentang-hero" style="margin-top: 0; padding-top: 130px;">
      <div class="tentang-hero-inner">
        <span class="hero-badge">
          <b-icon icon="info-circle-fill" font-scale="0.85"></b-icon>
          Tentang Kami
        </span>
        <h1>Aplikasi SIOPAPUA</h1>
        <p>
          Sistem informasi data terpilah OAP dan Non-OAP untuk mendukung
          pembangunan dan pelayanan dasar di Papua.
        </p>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container-standar" style="padding-top: 64px; padding-bottom: 80px;">

      <!-- About Card -->
      <div class="tentang-content-card">
        <h2>Tentang Aplikasi SIOPAPUA</h2>
        <p class="app-version">Hak Cipta &copy; 2020–{{ new Date().getFullYear() }} Pemerintah Daerah Papua</p>

        <p>
          <strong>Aplikasi SIOPAPUA</strong> dikembangkan oleh Pemerintah Daerah Papua untuk
          menyediakan informasi data terpilah OAP dan Non-OAP. Sesuai dengan amanat
          Undang-Undang OTONOMI KHUSUS (OTSUS) tentang PENGAKUAN dan PENGHORMATAN
          HAK-HAK DASAR ORANG ASLI PAPUA, data tersebut dapat membantu perencanaan
          pembangunan di tingkat kampung/kelurahan dan distrik dalam bidang ekonomi dan
          pelayanan dasar, khususnya bagi OAP.
        </p>

        <p>
          Selain itu, informasi tersebut diperlukan untuk MENGUKUR dan MEMASTIKAN
          pemanfaatan DANA OTSUS untuk meningkatkan KUALITAS HIDUP ORANG ASLI PAPUA.
        </p>

        <p>
          Aplikasi ini berfungsi untuk meningkatkan kualitas pengelolaan data dan informasi
          dasar kampung sehingga dapat mendukung administrasi pemerintahan, perencanaan
          pembangunan, peningkatan layanan dasar, dan pengembangan kegiatan ekonomi kampung.
        </p>

        <div class="warning-box">
          <strong>Perhatian:</strong> Aplikasi SIOPAPUA adalah milik Pemerintah Daerah Papua.
          Segala tindakan terhadap aplikasi yang dapat mengganggu dan menghambat keberhasilan
          pendataan Kampung akan ditindak sesuai Undang-undang dan hukum yang berlaku.
        </div>
      </div>

      <!-- Feature Cards -->
      <div class="text-center" style="margin-bottom: 32px;">
        <span class="section-label">Fitur Utama</span>
        <h2 class="section-title">Apa yang bisa SIOPAPUA lakukan?</h2>
      </div>

      <div class="tentang-features">
        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="people-fill" font-scale="1.2"></b-icon>
          </div>
          <h4>Data Kependudukan</h4>
          <p>Informasi data terpilah OAP dan Non-OAP di seluruh kampung dan kelurahan Papua.</p>
        </div>

        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="bar-chart-fill" font-scale="1.2"></b-icon>
          </div>
          <h4>Analisis Data</h4>
          <p>Visualisasi dan analisis data untuk mendukung perencanaan pembangunan daerah.</p>
        </div>

        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="building" font-scale="1.2"></b-icon>
          </div>
          <h4>Administrasi Kampung</h4>
          <p>Mendukung tata kelola administrasi pemerintahan di tingkat kampung dan distrik.</p>
        </div>

        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="heart-pulse-fill" font-scale="1.2"></b-icon>
          </div>
          <h4>Layanan Dasar</h4>
          <p>Mendorong peningkatan layanan dasar masyarakat bidang kesehatan dan pendidikan.</p>
        </div>

        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="cash-coin" font-scale="1.2"></b-icon>
          </div>
          <h4>Dana OTSUS</h4>
          <p>Mengukur dan memastikan pemanfaatan Dana OTSUS untuk kesejahteraan OAP.</p>
        </div>

        <div class="tentang-feature-card">
          <div class="feature-icon">
            <b-icon icon="map-fill" font-scale="1.2"></b-icon>
          </div>
          <h4>Potensi Kampung</h4>
          <p>Menampilkan potensi ekonomi dan sumber daya di setiap kampung Papua.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("SET_BG", false);
  },
};
</script>
